<template>
  <div v-show="value" ref="dialog" class="lottery_history_dialog">
    <img src="//vipcdn.mgtv.com/upload/20180408/close.png" class="close" @click="handleAction('cancel')"/>
    <div class="title">我的奖品</div>
    <div class="content" v-if="lottery_history && lottery_history.length > 0">
      <div v-for="item in lottery_history" class="item" @click="click_item(item)" v-show="item.award_type !== 0">
        <div class="recv_time">
          {{item.recv_time}}
        </div>
        <div class="award_name">
          {{item.award_name}}
        </div>
        <div class="submit_info" v-if="item.recv_info && item.recv_info.info">
          <div class="line">
            <div></div>
          </div>
          <div v-html="recv_info(item)"></div>
        </div>
        <div v-else class="tip_submit" v-show="[1,2,13].indexOf(item.award_type) !== -1">
          请提交
        </div>
      </div>
    </div>
    <div v-else class="content">
      <div class="no_content">
        您还没有奖品哟~
      </div>
    </div>
  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';
  import {setStyle} from '../../../tools/dom'
  import Cookie from '../../../tools/cookie';
  import {click_event} from '../../../tools/mgtv/analysis'
  import {getJSON} from '../../../api/myaxios'
  import process_award from '../../../components/ConfigUI/Lottery/process_award'
  import {GET_LOTTERY_HISTORY} from '../../../constant/eventbus'

  export default create({
    name: 'LotteryHistoryDialog',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },

    },
    data: function () {
      return {}
    },
    methods: {
      get_lottery_history() {
        window.$bus.$emit(GET_LOTTERY_HISTORY)
      },
      click_item(item) {
        process_award(item);
      },
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      },
      recv_info(award_info) {
        if (!award_info.recv_info) {
          return null
        }
        let info = award_info.recv_info.info;
        if (!info) {
          return null
        }
        try {
          info = JSON.parse(info)
        } catch (e) {
          return null
        }
        let info_str = ''
        if (info && Array.isArray(info)) {
          info.forEach(item => {
            info_str += `<div>${item.label}:${item.value}</div>`
          })
        }
        return info_str;
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {
      value(val) {
        if (val) { //显示
          this.get_lottery_history();
        }
        window.$bus.lottery.history_dialog_show = val;
      }
    },
    computed: {
      lottery_history() {
        return window.$bus.lottery.lottery_history;
      }
    }
  });
</script>


<style lang="stylus">
  @import "../../../share/mixins.styl"
  @import "../../../share/1px.styl"

  .lottery_history_dialog
    padding 1.1rem .3rem .8rem .3rem
    background white
    center()
    position fixed !important
    border-radius 0.2rem
    color #717171

    .close
      position absolute
      top -.2rem
      right 0
      width .73rem
      height .84rem
      z-index 2
      box-sizing content-box
      padding .2rem

    .title
      text-align center
      font-size .4rem
      margin-bottom: .2rem

    .content
      overflow-y scroll
      position relative
      width 6rem
      height 7rem
      padding-bottom .2rem
      .item
        position relative
        width: 100%;
        padding: .2rem .2rem;
        opacity: .6;
        color: #fff;
        border-radius: .2rem;
        /*background-color: #f76c07;*/
        background-color: #f76c07;
        margin-top: .2rem;
        .recv_time
          font-size: .3rem
          width 3.8rem
        .award_name
          padding-top .1rem
          font-size: .3rem
          width 3.8rem
        .submit_info
          position relative
          padding-top .2rem
          .line
            padding-bottom .2rem
            width 100%
            position relative
            margin 0 auto
            div:after
              setTopLine(#e4d2ad)
          div
            font-size .26rem
            word-break break-all
        .tip_submit
          font-size .26rem
          text-decoration underline
          position absolute
          top .5rem
          right .5rem

  .no_content
    position absolute
    text-align center
    top .5rem
    width 100%
    font-size .26rem
</style>



// WEBPACK FOOTER //
// src/components/Popups/LotteryHistoryDialog/LotteryHistoryDialog.vue